<template>
  <div class="atourist">
    <div class="title">
      <span>游客</span>
      <button @click="clickopen">
        <span>{{ stateText }}</span>
        <i :class="{'opentype' : !openState}"></i>
      </button>
    </div>
    <ul v-show="openState">
      <li v-for="item in displayList" :key="item.itemId">
        <span>{{ item.name }}</span>
        <span>{{ item.cerNo }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "atourist",
  props: ['itemList'],
  data(){
    return {
      openState:true,
      stateText:'展开',
      displayList: []
    }
  },
  methods:{
    clickopen(){
      this.openState = !this.openState;
      this.openState ? (this.stateText = '展开') : (this.stateText = '收起')
    }
  },
  watch:{
    itemList:{
      handler(newvalue){
        this.displayList = newvalue.reduce((previous, current) => {
          previous.push(...current.attrList)
          return previous
        }, []);
      },
      immediate:true,
      deep: true
    }
  }
};
</script>

<style scoped lang='less'>
.atourist{
  margin:0 .32rem;
  padding: .4rem .426667rem .533333rem .106667rem;
  .title{
    display: flex;
    justify-content: space-between;
    margin-bottom: .266667rem;
    &>span{
      font-size: .24rem * 2;
      font-weight: bold;
    }
    button{
      padding: 0 .32rem;
      border: 1px solid #3B6D9C;
      border-radius: .08rem;
      font-size: .32rem;
      font-weight: 400;
      width: .853333rem * 2;
      text-align: left;
      color: #3B6D9C;
      display: flex;
      justify-content: space-between;
      align-items: center;
      i{
        width:0;
        height:0;
        border-top:.066667rem * 2 solid transparent;
        border-bottom:.066667rem * 2 solid transparent;
        border-right:.066667rem * 2 solid transparent;
        border-left:.066667rem * 2 solid #3B6D9C;
        transform: translate(50%, 25%) rotate(90deg);
      }
      .opentype{
        transform: translate(100%, 0%);
      }
    }
  }
  ul{
    margin-top: .106667rem;
    font-size: .426667rem;
    line-height: .253333rem * 2;
    li{
      display: flex;
      justify-content: space-between;
      margin-top: .213333rem;
    }
  }
}
</style>
